import React, { useState } from "react";
import { useParams } from "react-router";
import {
  ID_TAB_EVENT_THINGYAN_2025,
  POPUP_VARIANT_EVENT_THINGYAN_2025,
} from "../helper/const";
import CollectPiece from "./components/EventThingyan_2025/CollectPiece";
import TakePrize from "./components/EventThingyan_2025/TakePrize";
import PrizeCollection from "./components/EventThingyan_2025/PrizeCollection";
import PieceCollection from "./components/EventThingyan_2025/PieceCollection";
import EventThingYanHome from "./components/EventThingyan_2025/Home";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { ID_PRIZE } from "./components/EventThingyan_2025/components/DefineData";
import ModalLogin from "../component/ModalLogin";
import { useDispatch, useSelector } from "react-redux";
import { curStateEventThingyan2025 } from "../Redux/selector";
import { setDataPopupError, setOpenPoupHistory } from "../Redux/futures/thingyan-2025/action";
import { DefineDataPopupWinner } from "./components/EventThingyan_2025/components/DefineData";
import PopupCommon from "./components/EventThingyan_2025/components/Popup/PopupCommon";
import ModalNotifycation from "../component/ModalNotifycation";
import { useTranslation } from "react-i18next";

export default function EventThingyan_2025() {
  const { id, idPrize } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dataEvent = useSelector(curStateEventThingyan2025);
  const [openModalLogin, setOpenModalLogin] = useState(false);

  const handleClosePoupHistory = () => {
    dispatch(setOpenPoupHistory(false));
  };
  
  const handleClosePopupError = () => {
    dispatch(setDataPopupError({
      isOpen: false,
      message: ""
    }))
  }

  const handleCheckPagePrize = () => {
    if (
      _.includes(location.pathname, ID_TAB_EVENT_THINGYAN_2025.prizeCollection)
    ) {
      let isCheckIdUrl = false;
      for (const key in ID_PRIZE) {
        if (+ID_PRIZE[key] === +idPrize) {
          isCheckIdUrl = true;
        }
      }
      return isCheckIdUrl;
    }
    return false;
  };

  const handleGetTab = () => {
    switch (id) {
      case ID_TAB_EVENT_THINGYAN_2025.home:
        return <EventThingYanHome setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_THINGYAN_2025.collectPiece:
        return <CollectPiece setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_THINGYAN_2025.takePrize:
        return <TakePrize setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_THINGYAN_2025.prizeCollection:
        return <PrizeCollection setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_THINGYAN_2025.pieceCollection:
        return <PieceCollection setOpenModalLogin={setOpenModalLogin} />;
      default:
        const isCheck = handleCheckPagePrize();
        return isCheck ? <TakePrize idPrize={+idPrize} /> : null;
    }
  };

  if (!dataEvent?.configEventThingyan?.is_show) {
    return null;
  }

  return (
    <ContainerEvent>
      {handleGetTab()}
      {openModalLogin ? (
        <ModalLogin
          open={openModalLogin}
          setOpenModalLogin={setOpenModalLogin}
          isGetContainer={false}
        />
      ) : null}
      {dataEvent.isOpenPopupHistory ? (
        <PopupCommon
          isOpenPopup={dataEvent.isOpenPopupHistory}
          handleCancel={() => handleClosePoupHistory()}
          variant={POPUP_VARIANT_EVENT_THINGYAN_2025.winner}
          data={DefineDataPopupWinner}
          getContainer={true}
        />
      ) : null}
      {dataEvent?.dataPopupError?.isOpen ? (
        <ModalNotifycation
          open={true}
          handleCancel={handleClosePopupError}
          title={t("error")}
          message={dataEvent?.dataPopupError?.message || t("mini_game.something_went_wrong")}
          isContainer
        />
      ) : null}
    </ContainerEvent>
  );
}

const ContainerEvent = styled.div`
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 992px) {
    margin-top: 12px;
  }
`;
